import { useLocalization } from 'localization'
import { message } from 'antd'
import { useMutation, useQueryClient } from 'react-query'
import { createOrganization, removeOrganizationById, removeOrganizationMember } from './services'
import queries from 'api/queries'
import { ResponseErrorType } from 'types/custom'

export const useCreateOrganization = () => {
	const { t } = useLocalization()
	const queryClient = useQueryClient()

	return useMutation(createOrganization, {
		onSuccess: (_, { name }) => {
			message.success(t('organizations.create.success', { name }))
			queryClient.invalidateQueries([queries.current])
		},
		onError: (error: ResponseErrorType) => {
			if (error?.response?.status !== 401) {
				message.error(t('organizations.create.error'))
			}
		},
	})
}

export const useRemoveOrganization = () => {
	const { t } = useLocalization()
	const queryClient = useQueryClient()

	return useMutation(removeOrganizationById, {
		onSuccess: () => {
			message.success(t('organizations.remove.success'))
			queryClient.invalidateQueries([queries.organizationById])
			queryClient.invalidateQueries([queries.organizationMembers])
			queryClient.invalidateQueries([queries.senderInvites])
			queryClient.invalidateQueries([queries.receiverInvites])
			queryClient.invalidateQueries([queries.current])
		},
		onError: (error: ResponseErrorType) => {
			if (error?.response?.status !== 401) {
				message.error(t('organizations.remove.error'))
			}
		},
	})
}

export const useRemoveOrganizationMember = () => {
	const { t } = useLocalization()
	const queryClient = useQueryClient()

	return useMutation(removeOrganizationMember, {
		onSuccess: () => {
			message.success(t('organizations.removeMember.success'))
			queryClient.invalidateQueries([queries.organizationMembers])
		},
		onError: (error: ResponseErrorType) => {
			if (error?.response?.status !== 401) {
				message.error(t('organizations.removeMember.error'))
			}
		},
	})
}
